module.exports = __webpack_public_path__ + "static/media/qtum.2aa8fb8e.svg";